<template>
<v-bottom-sheet v-model="visible" >
    <v-list class="pa-0 grey grey lighten-2" :three-line='$vuetify.breakpoint.xs' >
      <v-list-tile>
        <v-list-tile-avatar v-if='appointment && appointment.is_online' >
          <v-icon >headset_mic</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-action v-if='withPreview' >
          <v-btn
            v-if='screen === screens.ACTIONS'
            @click='screen=screens.PREVIEW' icon><v-icon>visibility</v-icon></v-btn>
          <v-btn
            v-if='screen === screens.PREVIEW'
            @click='screen=screens.ACTIONS' icon><v-icon>keyboard_backspace</v-icon></v-btn>
        </v-list-tile-action>

        <v-list-tile-action v-if='appointmentId' style="min-width:30px;" >
          <v-btn small icon
            @click="sharedialog=true" ><v-icon>ios_share</v-icon></v-btn>
        </v-list-tile-action>

        <v-list-tile-content >
          <v-list-tile-title>
            {{title}}
            <v-chip
              label dark
              v-if='formattedStatus && formattedStatus.title'
              :class='formattedStatus.theme' class='v-chip--x-small' >
              {{ formattedStatus.title }}
            </v-chip>
          </v-list-tile-title>
          <v-list-tile-sub-title v-if='appointment.product' >
            {{ product.title }}
            <span v-if='appointment.practitioner_name' >with {{appointment.practitioner_name}}</span>
            <span v-if='appointment.service_name' >@ {{appointment.service_name}}</span>
            <v-chip class='v-chip--x-small hidden-xs-only' v-if="appointment.address_name" >
              {{ appointment.address_name }}
            </v-chip>
            <!-- <span v-if="product.serviceData && product.serviceData.address" >
              {{product.serviceData.title}}
            </span> -->
          </v-list-tile-sub-title>
          <v-list-tile-sub-title v-if='$vuetify.breakpoint.xs' >
            <v-icon small >location_on</v-icon>
            {{ appointment.address_name }}.
            <v-spacer/>
            <strong class='ml-2' >{{ formatCurrency(appointment.currency, appointment.price) }}</strong>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <!-- disabling for now cause there's no easy way to get the start url -->

        <v-list-tile-action v-if='appointment && appointment.price' class='hidden-xs-only' >
          <v-chip @click="openGlobalDialog(true, 'InvoiceDetails', {appointment})" >
            {{ formatCurrency(appointment.currency, appointment.price) }}</v-chip>
        </v-list-tile-action>
        <v-list-tile-action
          v-if='appointmentDetail && appointmentDetail.zoom_start_url' >
          <v-btn
            :href='appointmentDetail.zoom_start_url'
            target='_blank'
            @click='visible=false;' flat text small color='primary' >
            Start meeting
            <v-icon small >open_in_new</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action>
        <v-btn @click='visible=false;' icon><v-icon>close</v-icon></v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <action-list :appointment='appointment' @actionselected='visible=false' />
    <v-divider></v-divider>
    <v-footer v-if='appointment' class='py-0 caption px-2' dark >
      <template v-if='appointment.tags' >
          Tags:
          <v-chip
            v-for='tag in appointment.tags'
            :key='tag'
            class='v-chip--x-small' outline >{{tag}}</v-chip>
      </template>
        Created {{ dateformat(appointment.created_date) }}.
        <v-spacer />
        <v-chip class='v-chip--x-small' outline label >#{{appointment.id}}</v-chip>
    </v-footer>
    <!-- <v-window v-model='screen' v-if='!readOnly' > -->
    <!-- <v-window v-model='screen' v-if='isOwner || isSpaceOwner' >
      <v-window-item>
        <action-list :appointment='appointment' />
      </v-window-item>
      <v-window-item>
        <v-card>
          <pre v-text="appointment"></pre>
        </v-card>
      </v-window-item>
    </v-window> -->
    <v-dialog v-model="sharedialog" width="460" :fullscreen="$vuetify.breakpoint.xs" >
      <v-card v-if="sharedialog" flat >
        <v-card-title class='overline py-1 grey lighten-4' >
          Share appointment
          <v-spacer/>
          <v-btn @click="sharedialog=false" small icon ><v-icon small >close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <share-appointment
          v-if="appointmentId"
          :appointment-id="appointmentId" />
      </v-card>
    </v-dialog>
</v-bottom-sheet>
</template>

<script>
import {
  ACTIVE_APPOINTMENT_DETAIL
} from '@/store/constants'
import ShareAppointment from '@/components/appointment/actions/ShareAppointment.vue'
import ActionList from '@/components/appointment/actions/ActionList.vue'

export default {
  name: 'AppointmentBottomSheet',
  components: { ActionList, ShareAppointment },
  props: {
    value: { type: Boolean, default: false },
    // title: { type: String, default: 'Choose an action' },
    appointment: { type: Object, default: () => { return {} } },
    readOnly: { type: Boolean, default: false }
  },
  data () {
    return {
      screen: 0,
      preview: false,
      visible: false,
      withPreview: false,
      sharedialog: false,
      screens: {
        ACTIONS: 0,
        PREVIEW: 1
      }
    }
  },
  mounted () {
    this.visible = this.value
  },
  watch: {
    value () {
      this.visible = this.value
    }
    // appointmentId () {
    //   console.log(this.appointmentId)
    //   if (this.appointmentId) {
    //     this.getAppointment(this.appointmentId)
    //   }
    // }
  },
  computed: {
    title () {
      if (this.appointment) {
        let title = ''
        if (this.appointment.title) {
          title = this.appointment.title
        } else {
          title = this.appointment.full_name
        }
        let formattedDate = this.dateformat(this.appointment.start_time, 'ddd DD MMM YYYY')
        title = `${title}. ${formattedDate}`

        return title
      }
      return 'Choose an action'
    },
    appointmentId () {
      if (this.appointment) {
        return this.appointment.id
      }
    },
    relationshipId () {
      if (this.appointment && this.appointment.client) {
        let rel = this.getRelationByClientId(this.appointment.client)
        return rel.id
      }
      return null
    },
    formattedStatus () {
      if (this.appointment && this.appointment.status) {
        return this.formatStatus(this.appointment.status)
      }
      return {}
    },
    appointmentDetail () {
      return this.getObjectPath(this.appointmentDetailRequest, 'result.data')
    },
    appointmentDetailRequest () {
      return this.$store.getters.getRequestById(ACTIVE_APPOINTMENT_DETAIL)
    },
    product () {
      if (this.appointment && this.appointment.product) {
        let product = this.appointment.product
        if (isNaN(product)) {
          return product
        } else {
          return this.getProductById(product, true)
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AppointmentBottomSheet.vue?4dc2df3a